import auditoria from "./auditoria/auditoria";
import dataAtencion from "./auditoria/dataAtencion";

export default {


  modules:{
    auditoria,
    dataAtencion
  }

};